import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'form.drivers.edit.fields.name.label' }),
    error: translate({ id: 'form.drivers.edit.errors.required' }),
    placeholder: translate({ id: 'form.drivers.edit.fields.name.label' }),
  }))

  return api
}
